import { iRouteKeysMap, iRouteMetaObject } from '@/types/app.types';
import abilityMapping from '../acl/ability-mapping';

export type iRouteMeta = {
  [key in (typeof ROUTES_KEYS_MAP)[keyof typeof ROUTES_KEYS_MAP]]: iRouteMetaObject;
};
/**
 * *It is very Important to have an entry for every route in both `routeKeysMap` & `routeMeta`,  to be able to access every route in the whole project.
 */
export const ROUTES_KEYS_MAP: iRouteKeysMap = {
  LOGIN: "_login",
  HOME: "_home",
  FORGOT_PASSWORD: "_forgot_password",
  SET_PASSWORD: "_set_password",
  RESET_PASSWORD: "_reset_password",
  UNAUTHORIZED: "_unauthorized",
  SOMETHING_WENT_WRONG: "_something_went_wrong",
  NOT_FOUND: "_not_found",
  DEFAULT: "_*",

  // PARTNER
  // MAPPING MODULE
  CITY_MAPPING: "_mapping",
  OMNIFUL_COUNTRY_CITIES: "_omniful_country_cities",
  SHIPPING_PARTNER_CITY_MAPPING: "_shipping_partner_city_mapping",
  OMNIFUL_CITIES: "_omniful_cities",
  OMNIFUL_STATE: "_omniful_states",
  OMNIFUL_COUNTRY: "_omniful_country",
  SALES_CHANNEL_CITY_MAPPING: "_sales_channel_city_mapping",

  // ORDERS MODULE
  ORDERS: "_orders",
  
  // BILLING MODULE
  BILLING_OMNIFUL_ENTITY: "_billing_omniful_entity",
  BILLING_TENANT_ENTITY: "_billing_tenant_entity",
  BILLING_PROFILE: "_billing_profile",
  BILLING_SINGLE_PROFILE: "_billing_single_profile",
  BILLING_CONTRACTS: "_billing_contracts",
  BILLING_SINGLE_CONTRACT: "_billing_single_contract",
  BILLING_BILLS: "_billing_bills",
  BILLING_SINGLE_BILL: "_billing_single_bill",
  BILLING_AD_HOC_ACTIVITIES: "_billing_ad_hoc_activities",
  BILLING_AD_HOC_USAGE: "_billing_ad_hoc_usage",
  BILLING_PROFILE_CREATE: "_billing_profile_create",
  BILLING_TRANSACTIONS: "_billing_transactions",
  
  //SETTINGS
  SETTINGS: "_settings",
  SALES_CHANNEL_APPS: "_sales_channel_apps",
  SELLER_SALES_CHANNELS: "_seller_sales_channels",
  SHIPPING_APPS_CONFIG: "_shipping_apps_config",
  USERS_SETTINGS: "_users_settings",
  ROLES_SETTINGS: "_roles_settings",

  // TENANT
  TENANTS: "_tenants",

  // SELLER
  SELLER: "_seller",

  // SKUs
  SKUS: "_skus",

  // Hubs
  HUBS: "_hubs",

  // Pricing Plans
  PRICING_PLANS: "_pricing_plans",
};

export const routeMeta: iRouteMeta = {
  [ROUTES_KEYS_MAP.LOGIN]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.FORGOT_PASSWORD]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.SET_PASSWORD]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.RESET_PASSWORD]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.NOT_FOUND]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.SOMETHING_WENT_WRONG]: {
    permissions: [],
    isPublicRoute: true,
  },
  [ROUTES_KEYS_MAP.UNAUTHORIZED]: {
    permissions: [],
    isPublicRoute: true,
  },

  // HOME MODULE
  [ROUTES_KEYS_MAP.HOME]: {
    primaryNavId: "_p_nav_home",
    hasSecondaryNavbar: false,
    permissions: [
      {
        action: abilityMapping.module.view.action,
        subject: abilityMapping.module.view.subject
      }
    ]
  },

  // MAPPING MODULE
  [ROUTES_KEYS_MAP.CITY_MAPPING]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.city_mapping.view.action,
        subject: abilityMapping.city_mapping.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.OMNIFUL_COUNTRY_CITIES]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.country.view.action, 
        subject: abilityMapping.country.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.shipping_partner_city_mapping.view.action,
        subject: abilityMapping.shipping_partner_city_mapping.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.OMNIFUL_CITIES]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.city.view.action,
        subject: abilityMapping.city.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.OMNIFUL_STATE]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.state.view.action,
        subject: abilityMapping.state.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.OMNIFUL_COUNTRY]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.country.view.action,
        subject: abilityMapping.country.view.subject
      }
    ],
  },
  [ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING]: {
    primaryNavId: "_p_nav_mapping",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.sales_channel_city_mapping.view.action,
        subject: abilityMapping.sales_channel_city_mapping.view.subject
      }
    ],
  },

  // SETTINGS MODULE
  [ROUTES_KEYS_MAP.SETTINGS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [],
  },

  [ROUTES_KEYS_MAP.TENANTS]: {
    primaryNavId: "_p_nav_tenants",
    hasSecondaryNavbar: false,
    permissions: [
      {
        action: abilityMapping.tenant.view.action,
        subject: abilityMapping.tenant.view.subject
      }
    ]
  },

  [ROUTES_KEYS_MAP.SELLER]: {
    primaryNavId: "_p_nav_seller",
    hasSecondaryNavbar: false,
    permissions: [
      {
        action: abilityMapping.seller.view.action,
        subject: abilityMapping.seller.view.subject
      }
    ]
  },

  [ROUTES_KEYS_MAP.SKUS]: {
    primaryNavId: "_p_nav_skus",
    hasSecondaryNavbar: false,
    permissions: [
      {
        action: abilityMapping.sku.view.action,
        subject: abilityMapping.sku.view.subject
      }
    ]
  },

  [ROUTES_KEYS_MAP.HUBS]: {
    primaryNavId: "_p_nav_hubs",
    hasSecondaryNavbar: false,
    permissions: [
      {
        action: abilityMapping.hub.view.action,
        subject: abilityMapping.hub.view.subject
      }
    ]
  },

  [ROUTES_KEYS_MAP.DEFAULT]: {
    permissions: [],
    isPublicRoute: true,
  },

  [ROUTES_KEYS_MAP.ORDERS]: {
    primaryNavId: "_p_nav_orders",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.sales_channel_app.view.action,
        subject: abilityMapping.sales_channel_app.view.subject,
      },
    ],
  },

  // BILLING MODULE
  [ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.omniful_billing_account.view.action,
        subject: abilityMapping.omniful_billing_account.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.tenant_billing_account.view.action,
        subject: abilityMapping.tenant_billing_account.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_PROFILE]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.profile_billing.view.action,
        subject: abilityMapping.profile_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_SINGLE_PROFILE]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.profile_billing.view.action,
        subject: abilityMapping.profile_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_PROFILE_CREATE]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    isSecondaryNavbarDefaultCollapsed: true,
    permissions: [
      {
        action: abilityMapping.profile_billing.create.action,
        subject: abilityMapping.profile_billing.create.subject,
      },
      {
        action: abilityMapping.profile_billing.edit.action,
        subject: abilityMapping.profile_billing.edit.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_CONTRACTS]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.contract_billing.view.action,
        subject: abilityMapping.contract_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_SINGLE_CONTRACT]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.contract_billing.view.action,
        subject: abilityMapping.contract_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_BILLS]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.bill_billing.view.action,
        subject: abilityMapping.bill_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_SINGLE_BILL]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    isSecondaryNavbarDefaultCollapsed: true,
    permissions: [
      {
        action: abilityMapping.bill_billing.view.action,
        subject: abilityMapping.bill_billing.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.adhoc.view.action,
        subject: abilityMapping.adhoc.view.subject,
      },
    ],
  },
  [ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.usage_adhoc.view.action,
        subject: abilityMapping.usage_adhoc.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.BILLING_TRANSACTIONS]: {
    primaryNavId: "_p_nav_billing",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.bill_billing.view.action,
        subject: abilityMapping.bill_billing.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.SALES_CHANNEL_APPS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.sales_channel_app.view.action,
        subject: abilityMapping.sales_channel_app.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.shipping_app.view.action,
        subject: abilityMapping.shipping_app.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.sales_channel_app.view.action,
        subject: abilityMapping.sales_channel_app.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.USERS_SETTINGS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.omniful_user.view.action,
        subject: abilityMapping.omniful_user.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.ROLES_SETTINGS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.omniful_role.view.action,
        subject: abilityMapping.omniful_role.view.subject,
      },
    ],
  },

  [ROUTES_KEYS_MAP.PRICING_PLANS]: {
    primaryNavId: "_p_nav_settings",
    hasSecondaryNavbar: true,
    permissions: [
      {
        action: abilityMapping.pricing_plans.view.action,
        subject: abilityMapping.pricing_plans.view.subject,
      },
    ],
  },
};
